import $axios from "../api/accessor";
import { $api } from "../api/api";

export const CitiesService = {
  async getAllCities() {
    let response = await $axios
      .get($api("cities"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
